var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-flat"},[_c('div',{staticClass:"panel-heading"},[_vm._v("\n        "+_vm._s(_vm.transEdit('coupons'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"panel-body"})])
}
var staticRenderFns = []

export { render, staticRenderFns }